export default "__VITE_ASSET__068249b2__"